"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitConfig = void 0;
const core_1 = require("../core");
const getInitConfig = (globalConfig) => (configBase) => (configProgram) => {
    Object.keys(configProgram).forEach(key => {
        if (!configBase[key]) {
            configBase[key] = {};
        }
        configBase[key] = Object.freeze((0, core_1.mergeDeep)(configBase[key], key === 'globalConfig' ? globalConfig : {}, configProgram[key]));
    });
    return configBase;
};
exports.getInitConfig = getInitConfig;
//# sourceMappingURL=getInitConfig.js.map